// extracted by mini-css-extract-plugin
export default {"element":"_404_element__sKbp5"};